/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, ReactNode, useContext, useState } from "react";
import { Breadcrumb } from "../models";

export interface AppBarState {
  title: string | null;
  breadcrumbs: Breadcrumb[];
  backUrl: string | null;
  rightContent: ReactNode | null;
  setTitle: (text: string | null) => void;
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
  setBackUrl: (url: string | null) => void;
  setRightContent: (content?: ReactNode) => void;
  setDefaults: () => void;
}

export const initialState: AppBarState = {
  title: "",
  breadcrumbs: [],
  backUrl: null,
  rightContent: null,
  setTitle: (text: string | null) => null,
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => null,
  setBackUrl: () => null,
  setRightContent: () => null,
  setDefaults: () => null,
};

export const AppBarContext = createContext(initialState);

export const AppBarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<string | null>(initialState.title);
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>(initialState.breadcrumbs);
  const [backUrl, setBackUrl] = useState<string | null>(null);
  const [rightContent, setRightContent] = useState<ReactNode | null>(null);

  const setDefaults = () => {
    setTitle(null);
    setBackUrl(null);
    setRightContent(null);
    setBreadcrumbs([]);
  };

  return (
    <AppBarContext.Provider value={{ title, setTitle, breadcrumbs, setBreadcrumbs, backUrl, setBackUrl, rightContent, setRightContent, setDefaults }}>
      {children}
    </AppBarContext.Provider>
  );
};

export const useAppBar = () => {
  return useContext(AppBarContext);
};
